<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper white">
            <h2 class="title text-center">碳跡川行</h2>
            <p class="carbon-text-sm">
                透過遊戲融入日常減碳觀念，讓學習減碳變得有趣且具有挑戰性，一起體驗減碳任務，同時獲得實用的減碳技巧吧！
            </p>
            <ul v-for="(game, index) in gameList" :key="index">
                <li class="itemStyle">
                    <a @click="goView('/carbon' + game.url)">
                        <div class="imgBox">
                            <img :src="game.imgUrl" alt="menu icon">
                        </div>
                        {{ game.listName }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            gameList: [
                {
                    imgUrl: require('@/assets/carbon-menu-forest.svg'),
                    listName: '固碳幫手',
                    url: '/helper',
                },
                {
                    imgUrl: require('@/assets/carbon-menu-carbon.svg'),
                    listName: '減碳計算機',
                    url: '/calculator',
                },
                {
                    imgUrl: require('@/assets/carbon-menu-puzzle.svg'),
                    listName: '負碳拼拼看',
                    url: '/puzzle',
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
    },
    methods: {
        goView(link) {
            this.$router.push(link).catch(() => { });
        },
    },
    mixins: [coreMixin],
};
</script>

<style scoped>
ul {
    position: relative;
}

.itemStyle {
    a {
        color: #000;
        background-color: #eef8ff;
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 18px;
        font-weight: 700;
        padding: 20px 16px;
        margin: 4px 0;
        text-align: left;
        border-radius: 12px;
        position: relative;
        gap: 8px;
    }

    .imgBox {
        width: 45px;
        height: 45px;
        margin-bottom: 4px;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.itemStyle::after {
    content: '';
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 24px;
    background-color: #d8efff;
    bottom: 0;
    left: 0;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}
</style>
